import React from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import config from '../config';
import loadingImg from "../assets/loading.gif"

const TradeConfirmationDetails = () => {
    const companyId = useSelector((state) => state.user.companyId);

    const [cashLedgerList, setCashLedgerList] = useState([])
    const [err, setErr] = useState("")
    const [inputs, setInputs] = useState({
        clientCode: "",
        fromDate: null,
        toDate: null,
        companyId: null,
    })
    const [isLoading, setIsLoading] = useState(false)
    const [currentDate, setCurrentDate] = useState('')

    const email = useSelector((state) => state.user.email);
    const navigate = useNavigate();
    useEffect(() => {
        if (email === null || email === "") {
            navigate("/")
        }
    })

    useEffect(() => {
        /*        const today = new Date();
                const dateString = today.toISOString().substring(0,10);
                setCurrentDate(dateString);
                inputs.fromDate = dateString;*/
        //handleSearch(null);
        //getCashLedger();
    }, [])



    const handleClearSearch = async (e) => {
        let clientCode = document.getElementById("client-Code");
        let fromDate = document.getElementById("fromDate");
        let toDate = document.getElementById("toDate");
        clientCode.value = ""
        fromDate.value = ""
        toDate.value = ""
        setInputs({
            clientCode: "",
            fromDate: null,
            toDate: null,
            companyId: companyId,
        });
        setCashLedgerList([]);
    }

    const handleSearch = async (e) => {
        try {
            inputs.companyId = companyId;
            setIsLoading(true);

            const res = await axios.post(config.BL_API_URL + "/transaction/v1/getTransactionReport", inputs);
            
            if (res.data) {
                setCashLedgerList(res.data)
                setIsLoading(false);
            }
            else {
                setErr("backend error")
                setIsLoading(false);
            }
        } catch (err) {
            setIsLoading(false);
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }



    function formatNumber(value) {
        return new Intl.NumberFormat('en-IN').format(value);
    }

    function formatDate(value) {
        if (value == null || value === undefined || value === "") {
            return;
        }
        return new Intl.DateTimeFormat('en-IN').format(value);
    }
    const handleChange = (e) => {
        setInputs(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }


    return (
        <div className="my-12 md:px-14 p-4 max-w-screen-2xl mx-auto ">
            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">

                    <div className="border rounded-lg divide-y divide-gray-200 py-5 ">
                        <div className='col-span-10'>
                            <div className=" col-span-1">
                                
                                <div className='col-span-10 flex  gap-x-1 px-1 py-1 overflow-ellipsis'>
                                    <div className="grid grid-cols-9 gap-2 justify-start border-0 border-red-500">
                                        <div className="col-span-1 gap-5 text-xs  ">
                                            <fieldset className='border-2 text-xs border-gray-200 p-0'>
                                                <legend className='m-1 p-0'>Client Code</legend>
                                                <input id="client-Code" w-full name="clientCode" onChange={handleChange} placeholder='Search by client code' className=" py-0 px-0 pe-0 block focus:outline-none" />
                                            </fieldset>
                                        </div>

                                        <div className="col-span-1 gap-5 text-xs ">
                                            <fieldset className='border-2 text-xs border-gray-200 p-0'>
                                                <legend className='m-1 p-0'>From Date</legend>
                                                <input
                                                    onChange={handleChange}
                                                    type="date" name="fromDate" id="fromDate" placeholder="from date"
                                                    className="py-0 px-0 pe-0 w-full block  focus:outline-none "
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="col-span-1 gap-5 text-xs ">
                                            <fieldset className='border-2 text-xs border-gray-200 p-0'>
                                                <legend className='m-1 p-0'>To Date</legend>
                                                <input
                                                    onChange={handleChange}
                                                    type="date" name="toDate" id="toDate" placeholder="to date"
                                                    className="py-0 px-0 pe-0 w-full block   focus:outline-none" />
                                            </fieldset>
                                        </div>
                                        <div className="col-span-1 gap-5 text-center text-xs " >
                                            <button type="button" onClick={e => handleSearch()} className="py-2 px-4 inline-flex right-0 gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary disabled:opacity-50 disabled:pointer-events-none " data-hs-overlay="#hs-basic-modal">

                                                <span>Search</span>
                                                {isLoading &&
                                                    <img src={loadingImg} alt="Icon" className="w-6 text-left justify-start items-right" />
                                                }

                                            </button>
                                        </div>
                                        <div className="col-span-1 gap-5 text-center text-xs " >

                                            <button type="button" onClick={e => handleClearSearch()} className="py-2 px-4 inline-flex right-0 gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary disabled:opacity-50 disabled:pointer-events-none " data-hs-overlay="#hs-basic-modal">
                                                Clear Search

                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="overflow-hidden">
                            <div className="overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200  ">
                                    <thead className="bg-gray-300 ">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase">Basket Name</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase">Client Code</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase">Scrip Name</th>
                                            <th scope="col" className="px-6 py-3 text-xs text-right font-medium text-gray-500 uppercase">Order Type</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase">Trade Date</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase">Net Rate</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase">Quantity</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cashLedgerList &&

                                            cashLedgerList.map((cashLedger, index) => (
                                                <tr key={index} className={`${index % 2 === 0 ? '' : 'bg-gray-100'} cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-200`}>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger[0]}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger[1]}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger[2]}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right  text-gray-800 ">{cashLedger[3]}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{cashLedger[4]}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{formatNumber(cashLedger[5])}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{formatNumber(cashLedger[6])}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{formatNumber(cashLedger[7])}</td>
                                                </tr>
                                            ))}
                                        {(cashLedgerList === null || cashLedgerList.length <= 0) &&
                                            <tr><td colSpan={9} className='text-center text-red-500 '>No records to display!</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default TradeConfirmationDetails;